import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NotificationService } from 'src/app/core/services/notification.service';

export interface ContactRepData {
  email: string;
}

@Component({
  selector: 'app-contact-rep',
  templateUrl: './contact-rep.component.html',
  styleUrls: ['../../audit-theme.css', './contact-rep.component.css'],
})
export class ContactRepComponent {
  constructor(
    public dialogRef: MatDialogRef<ContactRepComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ContactRepData,
    private notificationService: NotificationService,
  ) {}

  // A mailto: depends on the reader's machine having a mail program registered
  // with the browser, which plenty of locked-down work laptops don't — the
  // click then dead-ends with nothing on screen. So the dialog offers two
  // webmail compose pages alongside it (ordinary web pages, which always load)
  // and the address itself, and every route is visible before it's taken.
  get mailtoHref(): string {
    return `mailto:${this.data.email}`;
  }

  get gmailHref(): string {
    const to = encodeURIComponent(this.data.email);
    return `https://mail.google.com/mail/?view=cm&fs=1&to=${to}`;
  }

  get outlookHref(): string {
    const to = encodeURIComponent(this.data.email);
    return `https://outlook.office.com/mail/deeplink/compose?to=${to}`;
  }

  // Clipboard access needs a secure context and a live user gesture, and
  // navigator.clipboard is absent altogether over plain http. The address is on
  // screen either way, so a refusal just points back at it.
  async copyEmail(): Promise<void> {
    try {
      await navigator.clipboard.writeText(this.data.email);
      this.notificationService.info('Email address copied!');
    } catch {
      this.notificationService.warn(
        'Copy failed — please select the address above instead.',
      );
    }
  }
}
